const PRESET_COLORS = ['#4CC4D3', '#F06CA9', '#F4805B', '#FFEFE6', '#3c83d9'];

export function getColorForPreset(index: number): string {
  return PRESET_COLORS[index % PRESET_COLORS.length];
}
